import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IReadVerbPayload } from "../../../declarations/IReadVerbPayload";
import axios, { AxiosError } from "axios";

type ServiceError = {
    code: string;
    message: string;
};

export type SalesOrderStatusD365 =
    | "Loading"
    | "None"
    | "Canceled"
    | "Backorder"
    | "Invoiced"
    | "Delivered";

const getSalesOrderHeaderStatusD365 = async (
    payload: IReadVerbPayload,
): Promise<SalesOrderStatusD365> => {
    const axiosAuth = createAxiosClient("D365FO");

    try {
        const response = await axiosAuth.post<SalesOrderStatusD365>(
            `/SalesOrderHeader/GetSalesOrderHeaderStatusD365`,
            payload,
        );

        return response.data;
    } catch (err) {
        // Only intercept Axios errors with a response
        if (axios.isAxiosError(err) && err.response) {
            const data = err.response.data as ServiceError | undefined;

            // OPTION A: map NOT_FOUND → "None"
            if (data?.code === "SALESORDERHEADER.NOT_FOUND") {
                return "None";
            }
        }

        // Anything else is a real error
        throw err;
    }
};

export const useGetSalesOrderHeaderStatusD365 = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const orderNumber = payload.keys.salesOrderNumber as string;

    return useQuery<SalesOrderStatusD365>({
        queryKey: [
            "getSalesOrderHeaderStatusD365",
            {
                dataAreaId: dataAreaId ?? null,
                orderNumber: orderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!dataAreaId?.trim() || !orderNumber?.trim()) {
                throw new Error(
                    "Invalid params for getSalesOrderHeaderStatusD365",
                );
            }
            return getSalesOrderHeaderStatusD365(payload);
        },
        enabled: Boolean(dataAreaId?.trim()) && Boolean(orderNumber?.trim()),
        refetchOnWindowFocus: false,
        retry: false,
    });
};
